function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withUserFetch, withWorktypesFetch, withConfirmationTokenRetrieve, withCheckSession, withDraftData, withFullConfirmationTokenFetch, withQueryParamStore, withStepsMetaFetch } from '../../utils/middlewares';
import { confirmationTokenRetrieveSuccess } from '../../actions/user';
import _HomePage from '../page-home';
import ProjectPage from '../page-project';
import _ProjectByConfirmationTokenPage from '../page-project-from-confirmation-token';
import LoginPage from '../page-login';
import LogoutPage from '../page-logout';
import _ConfirmationPage from '../page-confirmation';
import _ConfirmationCallbackPage from '../page-confirmation-callback';
import SetPasswordPage from '../page-set-password';
import TestComponentPage from '../page-test-component';
import ErrorPage from '../page-error';
import PageDraftProject from '../page-draft-project';
import PageFakeProject from '../page-fake-project';
import _PageProjectList from '../page-project-list';
import _PageNotificationList from '../page-notification-list';
import _PageHemea from '../page-hemea';
import _PageLuko from '../page-luko';
import _PageCic from '../page-cic';
import _PageProjectDraft from '../page-project/PageProjectDraft';
import TallyForm from '../forms/tally-form';
import { DEMO_ROUTE, MY_FOLDERS_ROUTE } from '../../constants/router';
const ERROR_NODEV = {
  message: 'Cette page est réservée au développement'
};
const ERROR_NOAUTH = {
  message: 'Vous n\'êtes pas authentifié'
};
const ERROR_NOTFOUND = {
  message: 'Page inconnue'
};
const PageNotFound = props => /*#__PURE__*/React.createElement(ErrorPage, _extends({
  error: ERROR_NOTFOUND
}, props));
const DevRoute = _ref => {
  let {
    component: SubComponent,
    isAuthenticated,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: props => window.processRuntime.env?.NODE_ENV === 'development' ? /*#__PURE__*/React.createElement(SubComponent, props) : /*#__PURE__*/React.createElement(ErrorPage, _extends({
      error: ERROR_NODEV
    }, props))
  }));
};
const PrivateErrorRoute = _ref2 => {
  let {
    component: SubComponent,
    isAuthenticated,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: props => isAuthenticated ? /*#__PURE__*/React.createElement(SubComponent, props) : /*#__PURE__*/React.createElement(ErrorPage, _extends({
      error: ERROR_NOAUTH
    }, props))
  }));
};
const PrivateRedirectRoute = _ref3 => {
  let {
    component: SubComponent,
    isAuthenticated,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: props => isAuthenticated ? /*#__PURE__*/React.createElement(SubComponent, props) : /*#__PURE__*/React.createElement(Redirect, {
      to: "/login"
    })
  }));
};
const PrivateDraftRoute = _ref4 => {
  let {
    component: SubComponent,
    isAuthenticated,
    ...rest
  } = _ref4;
  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: props => isAuthenticated ? /*#__PURE__*/React.createElement(SubComponent, props) : /*#__PURE__*/React.createElement(Redirect, {
      to: "/projet/nouveau"
    })
  }));
};
const AnonRoute = _ref5 => {
  let {
    component: SubComponent,
    isAuthenticated,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: props => isAuthenticated ? /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    }) : /*#__PURE__*/React.createElement(SubComponent, props)
  }));
};
const routePropTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  isAuthenticated: PropTypes.bool
};
PrivateErrorRoute.propTypes = routePropTypes;
AnonRoute.propTypes = routePropTypes;
PrivateRedirectRoute.propTypes = routePropTypes;
PrivateDraftRoute.propTypes = routePropTypes;
const HomePage = withUserFetch(_HomePage);
const PageProjectList = compose(withUserFetch, withWorktypesFetch)(_PageProjectList);
const PageHemea = compose(withUserFetch)(_PageHemea);
const PageCic = compose(withUserFetch)(_PageCic);
const PageNotificationList = compose(withUserFetch)(_PageNotificationList);
const ProjectByConfirmationTokenPage = compose(withQueryParamStore(params => params.confirmationTokenValue, dispatch => confirmationToken => dispatch(confirmationTokenRetrieveSuccess(confirmationToken))), withFullConfirmationTokenFetch)(_ProjectByConfirmationTokenPage);
const ConfirmationPage = withConfirmationTokenRetrieve(_ConfirmationPage);
const ConfirmationCallbackPage = withConfirmationTokenRetrieve(_ConfirmationCallbackPage);
const PageProjectDraft = compose(withUserFetch, withWorktypesFetch, withStepsMetaFetch)(_PageProjectDraft);
const PageTallyForm = compose(withUserFetch)(TallyForm);
const MainPageSwitch = props => /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(PrivateRedirectRoute, _extends({
  exact: true,
  path: "/",
  component: HomePage
}, props)), /*#__PURE__*/React.createElement(PrivateRedirectRoute, _extends({
  exact: true,
  path: MY_FOLDERS_ROUTE,
  component: PageProjectList
}, props)), /*#__PURE__*/React.createElement(PrivateRedirectRoute, _extends({
  exact: true,
  path: "/hemea",
  component: PageHemea
}, props)), /*#__PURE__*/React.createElement(PrivateRedirectRoute, _extends({
  exact: true,
  path: "/cic",
  component: PageCic
}, props)), /*#__PURE__*/React.createElement(PrivateRedirectRoute, _extends({
  exact: true,
  path: "/luko",
  component: _PageLuko
}, props)), /*#__PURE__*/React.createElement(PrivateRedirectRoute, _extends({
  exact: true,
  path: "/mes-notifications",
  component: PageNotificationList
}, props)), /*#__PURE__*/React.createElement(PrivateRedirectRoute, _extends({
  exact: true,
  path: "/formulaire/:projectId/:formId",
  component: PageTallyForm
}, props)), /*#__PURE__*/React.createElement(PrivateDraftRoute, _extends({
  exact: true,
  path: "/projet",
  component: HomePage
}, props)), /*#__PURE__*/React.createElement(Route, _extends({
  exact: true,
  path: "/projet/brouillon",
  component: PageDraftProject
}, props)), /*#__PURE__*/React.createElement(Route, _extends({
  exact: true,
  path: "/projet/nouveau",
  component: PageFakeProject
}, props)), /*#__PURE__*/React.createElement(PrivateRedirectRoute, _extends({
  exact: true,
  path: "/projet/:id",
  component: ProjectPage
}, props)), /*#__PURE__*/React.createElement(PrivateRedirectRoute, _extends({
  exact: true,
  path: "/projet/:id/:slider",
  component: ProjectPage
}, props)), /*#__PURE__*/React.createElement(PrivateRedirectRoute, _extends({
  exact: true,
  path: "/confirmation-token/:confirmationTokenValue/project",
  component: ProjectByConfirmationTokenPage
}, props)), /*#__PURE__*/React.createElement(AnonRoute, _extends({
  exact: true,
  path: "/login",
  component: LoginPage
}, props)), /*#__PURE__*/React.createElement(PrivateErrorRoute, _extends({
  exact: true,
  path: "/login-callback",
  component: () => /*#__PURE__*/React.createElement(Redirect, {
    to: "/"
  })
}, props)), /*#__PURE__*/React.createElement(PrivateRedirectRoute, _extends({
  exact: true,
  path: "/logout",
  component: LogoutPage
}, props)), /*#__PURE__*/React.createElement(PrivateErrorRoute, _extends({
  exact: true,
  path: "/confirmation",
  component: ConfirmationPage
}, props)), /*#__PURE__*/React.createElement(PrivateErrorRoute, _extends({
  exact: true,
  path: "/confirmation-callback",
  component: ConfirmationCallbackPage
}, props)), /*#__PURE__*/React.createElement(PrivateRedirectRoute, _extends({
  exact: true,
  path: "/mot-de-passe",
  component: SetPasswordPage
}, props)), /*#__PURE__*/React.createElement(DevRoute, _extends({
  exact: true,
  path: "/test-component",
  component: TestComponentPage
}, props)), /*#__PURE__*/React.createElement(PrivateRedirectRoute, _extends({
  exact: true,
  path: DEMO_ROUTE,
  component: PageProjectDraft
}, props)), /*#__PURE__*/React.createElement(Route, {
  component: PageNotFound
}));
MainPageSwitch.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired
};
export default withDraftData(withCheckSession(MainPageSwitch, false));